export default "__VITE_ASSET__CtHvnVVR__"